import React from 'react';
import styled from '@emotion/styled';
import {ReactSketchCanvas} from 'react-sketch-canvas';
import {renderToStaticMarkup} from 'react-dom/server';

import backgroundImage from '../images/transp_bg.png';
import PenCursor from '../images/icons/penRegular';

const Container = styled.div`
  background-image: url(${backgroundImage});
  min-height: calc(100vh - 96px); /* 96 is header height */
  /* like display:flex but will allow bleeding over the window width */
  min-width: 100vw;
  display: inline-flex;
`;

const canvasStyles = {
  position: 'absolute',
  height: 'calc(100vh - 96px)',
  width: '100vw',
  // cursor: `url(${penCursor}) 0 30, auto`,
};

export default function Board({word, pen, canvasRef}) {
  const svgString = encodeURIComponent(renderToStaticMarkup(<PenCursor fillColor={pen.colorHex} />));
  const penStrokeWidth = pen?.size === 'THIN' ? 4 : 8;

  return (
    <Container style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
      <p style={{fontFamily: 'Greycliff', fontSize: 125, fontWeight: 800}}>{word}</p>

      {!!pen && (
        <ReactSketchCanvas
          style={{...canvasStyles, cursor: `url("data:image/svg+xml;utf8,${svgString}") 0 30, auto`}}
          canvasColor="rgba(0, 0, 0, 0)"
          strokeWidth={penStrokeWidth}
          strokeColor={pen.colorHex}
          ref={canvasRef}
        />
      )}
    </Container>
  );
}
